/**
 * Visibilité sidebar / route hub Communication (`/app/marketing`).
 * Tout compte pro authentifié voit l’entrée ; le contenu hub est réservé
 * à Premium (`MarketingToolsPage` + `CommunicationPremiumUpsell`).
 */
export function canAccessMarketingTools(opts: {
  email?: string | null;
  proId?: number | null;
}): boolean {
  return Number(opts.proId) > 0;
}

/** @deprecated Utiliser canAccessMarketingTools({ proId }) */
export function isEmailInMarketingToolsAllowlist(
  email: string | null | undefined
): boolean {
  void email;
  return false;
}
